import { render, staticRenderFns } from "./Terminologies.vue?vue&type=template&id=fd3f0940&scoped=true"
import script from "./Terminologies.vue?vue&type=script&lang=js"
export * from "./Terminologies.vue?vue&type=script&lang=js"
import style0 from "./Terminologies.vue?vue&type=style&index=0&id=fd3f0940&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd3f0940",
  null
  
)

export default component.exports